import React from "react";
import BlogTwentyThree from "../component/BlogTwentyThree";

function BlogTwentyThreeContainer() {
  return <BlogTwentyThree />;
}
export default BlogTwentyThreeContainer;
